import Header from './components/ui/Header';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Projects from './components/sections/Projects';
import Experience from './components/sections/Experience';
import Writing from './components/sections/Writing';
import Recommendations from './components/sections/Recommendations';
import Support from './components/sections/Support';
import Contact from './components/sections/Contact';
import { DanielController } from './components/ui/PixelDaniel';

function App() {
  return (
    <div className="min-h-screen bg-bg-dark text-text-primary">
      <Header />
      <DanielController />
      <main>
        <Hero />
        <About />
        <Writing />
        <Projects />
        <Experience />
        <Recommendations />
        <Support />
        <Contact />
      </main>

      {/* Footer */}
      <footer className="bg-bg-darker py-8 text-center text-text-secondary">
        <div className="container-custom px-6">
          <p className="mb-2">
            &copy; {new Date().getFullYear()} Daniel Ostrow. All rights reserved.
          </p>
          <p className="text-sm">
            Built with <span className="text-quantum-blue">React</span>,{' '}
            <span className="text-quantum-green">Three.js</span>, and{' '}
            <span className="text-quantum-purple">TypeScript</span>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
